import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  timeout: 10000, // 10 second timeout
  maxRedirects: 0,
});

// Rate limiting for requests
const requestMap = new Map();
const RATE_LIMIT_MS = 1000; // 1 second between requests

// Add token to requests with rate limiting
api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add security headers
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  
  // Rate limiting per endpoint
  const key = `${config.method}-${config.url}`;
  const lastRequest = requestMap.get(key);
  
  if (lastRequest && Date.now() - lastRequest < RATE_LIMIT_MS) {
    await new Promise(resolve => setTimeout(resolve, RATE_LIMIT_MS - (Date.now() - lastRequest)));
  }
  
  requestMap.set(key, Date.now());
  
  return config;
});

// Handle security errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      
      // Handle security-related errors
      if (status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      } else if (status === 403) {
        console.error('Acesso negado:', error.response.data.error);
      } else if (status === 423) {
        console.error('Conta bloqueada:', error.response.data.error);
      } else if (status === 429) {
        console.error('Muitas requisições:', error.response.data.error);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
